import { ReactNode } from "react";
import { Button, Icon } from "@/shared/ui";

type Props = {
  title: string;
  isOpen?: boolean;
  titleOpen?: string;
  onBack?: () => void;
  children?: ReactNode;
};

export default function HeaderTitle({ isOpen, title, titleOpen, onBack, children }: Props) {
  return isOpen ? (
    <div className="flex items-center gap-2.5">
      <Button variant="soft" color="matched" className="shrink-0 size-8 p-0" onClick={onBack}>
        <Icon name="triangle-left" className="w-1.5 h-2.5" />
      </Button>
      <p className="text-18 text-white font-bold">{titleOpen}</p>
    </div>
  ) : (
    <div className="flex items-center w-full">
      <p className="text-18 text-white font-bold leading-none">{title}</p>
      {children}
    </div>
  );
}
